import { useMemo } from 'react'

import { useIntl } from 'react-intl'

import { BreadcrumbsProps } from 'app/components/common/Breadcrumbs'
import { useGetCategoriesData } from 'app/features/HelpCenter/hooks/useGetCategoriesData'

interface UseGenerateBreadcrumbsAndTitleProps {
  categorySlug: string
  articleTitle?: string
  isMultipleCategories?: boolean
}

const useGenerateBreadcrumbsAndTitle = ({
  categorySlug,
  articleTitle,
  isMultipleCategories
}: UseGenerateBreadcrumbsAndTitleProps) => {
  const { formatMessage } = useIntl()

  const {
    categoryName,
    subcategoryName,
    currentCategorySlug,
    currentSubcategorySlug
  } = useGetCategoriesData({
    categorySlug
  })

  const breadcrumbsItems = useMemo(() => {
    if (isMultipleCategories) {
      return [
        {
          child: formatMessage({
            defaultMessage: 'Help Centre'
          }),
          href: '/help-centre'
        },
        {
          child: articleTitle,
          href: '#'
        }
      ]
    }

    return [
      {
        child: formatMessage({ defaultMessage: 'Help Centre' }),
        href: '/help-centre'
      },
      {
        child: categoryName,
        href: `/help-centre/${currentCategorySlug}`
      },
      !!subcategoryName && {
        child: subcategoryName,
        href: `/help-centre/${currentSubcategorySlug}`
      },
      !!articleTitle && {
        child: articleTitle,
        href: '#'
      }
    ].filter(Boolean) as BreadcrumbsProps['items']
  }, [categoryName, subcategoryName, isMultipleCategories])

  return { breadcrumbsItems, title: categoryName }
}

export default useGenerateBreadcrumbsAndTitle
